export default {
      id: "icon--acco-my-details-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--acco-my-details-usage",
      toString: function () {
        return this.url;
      }
    }